import { IntlShape } from "react-intl";
import { createColumnHelper, ColumnDef } from "types/common/Header";
import { IndustrySpecialist } from "./models/response/get-industry-specialists-response";
import { INDUSTRY_SPECIALIST_KEYS } from "./industry-specialist.constants";

const columnHelper = createColumnHelper<IndustrySpecialist>();

export const getIndustrySpecialistHeaders = (
  intl: IntlShape
): ColumnDef<IndustrySpecialist>[] => [
  columnHelper.accessor("name", {
    displayName: intl.formatMessage({ id: "baseTable.name" }),
    sortable: true,
    sortKey: INDUSTRY_SPECIALIST_KEYS.NAME,
    alignRight: false,
    cell: (row) => <span>{row.name}</span>,
  }),
  columnHelper.accessor("email", {
    displayName: intl.formatMessage({ id: "baseTable.email" }),
    sortable: true,
    sortKey: INDUSTRY_SPECIALIST_KEYS.EMAIL,
    alignRight: false,
    cell: (row) => <span>{row.email}</span>,
  }),
];
